import { ReactComponent as AutochapeauLogo } from "../../assets/autochapeau.svg";

const PageBannerLoading = () => (
    <div className="ac-page-loading" role="status" aria-label="Loading page">
      <div className="ac-page-loading__content">
        <AutochapeauLogo className="ac-page-loading__logo" aria-hidden="true" />
        <span className="ac-page-loading__line" aria-hidden="true" />
      </div>
    </div>
);

export default PageBannerLoading;
